// src/components/plan/PlanLayout.jsx
// Pooled inbox SP5 — the dark frame every plan screen sits in (proto
// plan.css: `.plan-page`, `.plan-logo`): `stars-dark` on the foundation, the
// white STARS logo centred above the header, a wide column for the plan grid
// and a narrow one for payment and the receipt. Token substitutions (no theme
// step for the prototype's px): 1240px → max-w-screen-xl (1280px), 560px →
// max-w-xl (576px); the logo's 168px → w-40 (160px), 132px under 820px →
// w-32 (128px) under md (768px).
import React from "react";
import { cn } from "../ui";
import logo from "../../assets/images/stars-logo-white.png";
import { PLAN_LOGO_ALT } from "./planCopy";

export default function PlanLayout({ width = "narrow", children }) {
  return (
    <div className="stars-dark tw-min-h-screen tw-bg-bg tw-font-sans tw-text-text">
      <main
        className={cn(
          "tw-mx-auto tw-w-full tw-px-4 tw-pb-12 tw-pt-6 md:tw-px-6 md:tw-pb-16 md:tw-pt-8",
          width === "wide" ? "tw-max-w-screen-xl" : "tw-max-w-xl",
        )}
      >
        <div className="tw-mb-6 tw-flex tw-justify-center md:tw-mb-8">
          <img src={logo} alt={PLAN_LOGO_ALT} className="tw-w-32 md:tw-w-40" />
        </div>
        {children}
      </main>
    </div>
  );
}
